import authSagas from './auth.saga';
import calendarSagas from './calendar.saga';
import organizationSagas from './organization.saga';
import categoriesSaga from './categories.saga';

export default [...authSagas, ...calendarSagas, ...organizationSagas, ...categoriesSaga];
